// Imports from node_modules, installed via 'yarn add ...'
import * as bootstrap from 'bootstrap'; // Bootstrap (~97Kb)
// import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper'; // Swiper (~??Kb)
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules';
import 'waypoints/lib/noframework.waypoints.min.js'; // Waypoints (intersection observer utility) (~10Kb)
import Cookies from 'js-cookie'; // Cookies.js (~2Kb)
import AOS from 'aos'; // Animate on Scroll (~14Kb)
import TomSelect from 'tom-select'; // TomSelect (~52Kb)
import PhotoSwipe from 'photoswipe'; // PhotoSwipe (~56Kb)
// import Masonry from 'masonry-layout'; // Masonry (~8Kb)

Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Swiper = Swiper;
window.Cookies = Cookies;
window.TomSelect = TomSelect;  
window.PhotoSwipe = PhotoSwipe;
// window.Masonry = Masonry;

// Initialisation
AOS.init({
  once: true,
  offset: 120, // Offset from the original trigger point (in px)
  disable: false, // Enable animations on all devices
  startEvent: 'DOMContentLoaded' // Start detecting elements on DOM ready
});